<template >
  <!-- Common Filters -->

  <div v-if="isCommon" >
    <Card :title="'Vehicle Common Filters'" >
      <transition name="fade">
      <ManageZIPVIN v-if="showManageZipVin"
        @close="showManageZipVin = false"
        @save="updateZipVin"
        :editable="isCreate || isEdit"
        :informative-campaign="userPreferences.onlyInformativeCampaign"
        :mvs="mvs"
        :mvs-to-exclude="mvsToExclude"
        :vin="vin"
        :vin-to-exclude="vinToExclude"
        :zipCodes="zipCodes"
      />
    </transition>
      <template slot="actions">
        <button class="slds-button slds-button_neutral" @click="showManageZipVin = true"> {{'Manage ZIP/VIN'}} </button>
      </template>
     <!-- CarAge -->
      <div class="row slds-m-top--medium">
        <div class="slds-form-element col slds-size--medium">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.carAge')"
            :original-value="originalValues"
            filter-type="carAge"
            ref="filter_carAge"
            v-if="isCreate || isEdit"
            v-model="carAges"
          />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.carAge')"
            :value="carAgeDisplayText | capitalize"
            type="text"
            v-else />
        </div>
      </div>

    <div class="row slds-m-top--medium" >
      <!-- Registration date -->
       <div class="slds-form-element col slds-size--medium" >
        <div class="slds-size--medium">
              <GenericFilter
                filter-mode="add-remove"
                :label="$t('campaignDesigner.targetDefinition.firstRegistrationDate')"
                filter-type="range"
                input-type="date"
                ref="filter_firstRegistrationDate"
                v-if="isCreate || isEdit"
                v-model="firstRegistrationDate" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.firstRegistrationDate')"
                :value="firstRegistrationDate"
                item-type="date"
                type="range"
                v-else/>
        </div>
      </div>

      <!-- Mileage-->
      <div class="slds-form-element col slds-size--medium">
              <GenericFilter
                :filter-mode="filterMode"
                :label="$t('campaignDesigner.targetDefinition.mileages')"
                :original-value="originalValues"
                input-type="number"
                ref="filter_mileage"
                filter-type="range"
                v-if="isCreate || isEdit"
                v-model="mileages" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.mileages')"
                :value="mileages"
                type="range"
                v-else />
      </div>
    </div>

     <Accordion class="slds-m-top--medium">
        <AccordionItem :title="$t('campaignDesigner.targetDefinition.warrantyExtension')" accordion-item-id="warrantyExtension">
          <!-- Warranty Extension-->
          <div class="row slds-m-top--medium">
            <div class="slds-form-element col row slds-size--medium">
              <div v-if="isCreate || isEdit">
                <Picklist
                  :label="$t('campaignDesigner.targetDefinition.warrantyExtension')"
                  :options="config.warrantyExtensionInclude.options"
                  labels-prefix="filters"
                  v-model="warrantyExtensionInclude" />

                <Input
                  :disabled="warrantyExtensionInclude === 'noFilter'"
                  :label="$t('general.from')"
                  :validation="[{name: 'is-date-before', param: warrantyExtension.toDate}]"
                  ref="filter_warrantyExtension_fromDate"
                  type="date"
                  v-model="warrantyExtension.fromDate" />

                <Input
                  :disabled="warrantyExtensionInclude === 'noFilter'"
                  :label="$t('general.to')"
                  ref="filter_warrantyExtension_toDate"
                  type="date"
                  v-model="warrantyExtension.toDate" />
              </div>

              <div v-else>
                <OutputField
                  :label="$t('campaignDesigner.targetDefinition.warrantyExtension')"
                  :options="config.warrantyExtensionInclude.options"
                  :value="warrantyExtensionInclude"
                  labels-prefix="filters"
                  type="picklist" />

                <OutputField type="custom" v-if="warrantyExtension.fromDate && warrantyExtension.toDate">
                  {{$t('general.from')}} {{warrantyExtension.fromDate | formatDate($t('general.dateFormat'))}} {{$t('general.to')}} {{warrantyExtension.toDate | formatDate($t('general.dateFormat'))}}
                </OutputField>
              </div>
            </div>

            <div class="slds-form-element col row slds-size--medium">
              <div v-if="isCreate || isEdit">
                <Input
                  :label="$t('campaignDesigner.targetDefinition.carsWithoutWarranties')"
                  :disabled="warrantyExtensionInclude === 'noFilter'"
                  type="checkbox"
                  v-model="warrantyExtension.carsWithoutWarranties.selected" />
              </div>

              <div v-else>
                <OutputField
                  :label="$t('campaignDesigner.targetDefinition.carsWithoutWarranties')"
                  :value="warrantyExtension.carsWithoutWarranties.selected"
                  type="checkbox" />
              </div>
            </div>
          </div>
        </AccordionItem>
        </Accordion>

    </Card>
    <hr>
    <Card :title="'Customer Common Filters'" style="padding: 1%">
       <div class="slds-form-element col slds-size--medium">
          <ChannelFilter
            :channels="channelOptions"
            labels-prefix="channels"
            mode="view"
            v-model="channels"
          />
        </div>
        <!-- Client Type common field -->
        <div class="row slds-m-top--medium">
           <div class="slds-form-element col slds-size--medium">
          <Picklist
            :label="$t('campaignDesigner.targetDefinition.communicationChannelsFilterLogic.label')"
            :options="config.communicationChannelsFilterLogic.options"
            :validation="['required']"
            :disabled="!(channels.includes('email') && channels.includes('sms'))"
            ref="filter_channelsLogic"
            labels-prefix="campaignDesigner.targetDefinition.communicationChannelsFilterLogic"
            v-if="isCreate || isEdit"
            v-model="communicationChannelsFilterLogic" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.communicationChannelsFilterLogic.label')"
            :options="config.communicationChannelsFilterLogic.options"
            :value="communicationChannelsFilterLogic"
            labels-prefix="campaignDesigner.targetDefinition.communicationChannelsFilterLogic"
            type="picklist"
            v-else />
        </div>

          <div class="slds-form-element col slds-size--medium">
            <GenericFilter
              :label="$t('campaignDesigner.targetDefinition.excludeContactsWithoutAssociatedDealer')"
              :tooltip="$t('campaignDesigner.targetDefinition.dealerCluster.tooltip')"
              filter-type="exact"
              ref="filter_excludeContactsWithoutAssociatedDealer"
              v-if="isCreate || isEdit"
              v-model="excludeContactsWithoutAssociatedDealer" />

            <OutputField
              :label="$t('campaignDesigner.targetDefinition.excludeContactsWithoutAssociatedDealer')"
              :tooltip="$t('campaignDesigner.targetDefinition.dealerCluster.tooltip')"
              :value="excludeContactsWithoutAssociatedDealer"
              type="boolean"
              v-else />
          </div>
        </div>

        <!-- Channel, Communication Channels filter logic -->
      <div class="row slds-m-top--medium">
        <div class="slds-form-element col slds-size--medium">
          <Picklist
            :label="$t('campaignDesigner.targetDefinition.vocation')"
            :options="config.vocation.options"
            hide-empty-value
            ref="filter_vocation"
            v-if="(isCreate || isEdit)"
            v-model="vocation" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.vocation')"
            :options="config.vocation.options"
            :value="vocation"
            type="picklist"
            v-else />
        </div>
      </div>
      <br>

    </Card>

  </div>

  <div v-else >
    <!-- Offer Filters -->
    <Card additional-classes="slds-card_boundary" :title="exp ? 'exP Vehicle Filters' : 'exF Vehicle Filters'" >
      <button class="slds-button slds-button_neutral" v-if="!loading && !exp" @click="showModal = true" slot="actions">
       {{ !userPreferences.onlyInformativeCampaign ? 'Manage MVS/VIN' : 'Manage MVS' }}
      </button>
      <button class="slds-button slds-button_neutral" v-if="!loading && exp" @click="showModal = true" slot="actions">
        {{!userPreferences.onlyInformativeCampaign ? 'Manage LCDV9/VIN' : 'Manage LCDV9'}}
      </button>
      <!-- Brand, CarAge -->
      <div class="row">
        <div class="slds-form-element col slds-size--medium">
          <BrandFilter
            :brands="allBrands"
            labels-prefix="campaignDesigner.targetDefinition.brands"
            mode="view"
            ref="filter_brand"
            v-model="brands"
          />
        </div>

        <div class="slds-form-element col slds-size--medium" v-if="(isOffer || !userPreferences.onlyInformativeCampaign)">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.carAge')"
            :original-value="originalValues"
            filter-type="carAge"
            ref="filter_carAge"
            v-if="isCreate || isEdit"
            v-model="carAges"
          />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.carAge')"
            :value="carAgeDisplayText | capitalize"
            type="text"
            v-else />
        </div>
      </div>

      <!-- Mileage, Fuel Type -->
      <div class="row slds-m-top--medium">
        <div class="slds-form-element col slds-size--medium" v-if="(isOffer || !userPreferences.onlyInformativeCampaign)">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.mileages')"
            :original-value="originalValues"
            input-type="number"
            ref="filter_mileage"
            filter-type="range"
            v-if="isCreate || isEdit"
            v-model="mileages" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.mileages')"
            :value="mileages"
            type="range"
            v-else />
        </div>


        <!-- EXF FUEL -->
        <div class="slds-form-element col slds-size--medium" v-if="!exp">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.fuelTypes.label')"
            :options="(config ? config.fuelTypes.options : [])"
            filter-type="included"
            labels-prefix="campaignDesigner.targetDefinition.fuelTypes"
            is-multi-picklist
            ref="filter_fuelType"
            v-if="isCreate || isEdit"
            v-model="fuelTypes" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.fuelTypes.label')"
            :options="(config ? config.fuelTypes.options : [])"
            :value="fuelTypes"
            labels-prefix="campaignDesigner.targetDefinition.fuelTypes"
            type="multipicklist"
            v-else />


        </div>
        <!-- EXP FUEL -->
        <div class="slds-form-element col slds-size--medium" v-else>
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.fuelTypes.label')"
            :options="(config ? config.exp_fuelTypes.options : [])"
            sort-label
            filter-type="included"
            labels-prefix="campaignDesigner.targetDefinition.fuelTypes"
            is-multi-picklist
            ref="filter_exp_fuelType"
            v-if="isCreate || isEdit"
            v-model="exp_fuelTypes" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.fuelTypes.label')"
            :options="(config ? config.exp_fuelTypes.options : [])"
            :value="exp_fuelTypes"
            labels-prefix="campaignDesigner.targetDefinition.fuelTypes"
            type="multipicklist"
            v-else />
        </div>
      </div>

      <!-- Model Year From, Segment -->
      <div class="row slds-m-top--medium"  v-if="!exp">
        <div class="slds-form-element col slds-size--medium">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.modelYearFrom')"
            :options="config.modelYearFrom.options"
            :isExP="exp"
            filter-type="included"
            is-multi-picklist
            ref="filter_modelYearFrom"
            v-if="isCreate || isEdit"
            v-model="modelYearFrom" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.modelYearFrom')"
            :options="config.modelYearFrom.options"
            :value="modelYearFrom"
            type="array"
            v-else />
        </div>

        <div class="slds-form-element col slds-size--medium">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.segment')"
            :options="config.segment.options"
            :isExP="exp"
            filter-type="included"
            is-multi-picklist
            ref="filter_segment"
            v-if="isCreate || isEdit"
            v-model="segment"
          />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.segment')"
            :options="config.segment.options"
            :value="segment"
            type="array"
            v-else />
        </div>
      </div>

      <!-- Engine Size, Dealer Cluster -->
      <div class="row slds-m-top--medium" v-if="!exp">
        <div class="slds-form-element col slds-size--medium">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.engineSize')"
            :options="config.engineSize.options"
            :isExP="exp"
            filter-type="included"
            is-multi-picklist
            ref="filter_engineSize"
            v-if="isCreate || isEdit"
            v-model="engineSize" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.engineSize')"
            :options="config.engineSize.options"
            :value="engineSize"
            type="array"
            v-else />
        </div>

          <div class="slds-form-element col slds-size--medium">
            <DealerClusterFilter
              :editable="isCreate || isEdit"
              :filter-mode="filterMode"
              :isExP="exp"
              :options="config.dealerCluster.options"
              :selected-dealers-map="dealers"
              @dealersUpdate="handleDealersUpdate"
              v-model="dealerCluster" />
        </div>
      </div>

      <!-- Camper, target cluster -->
      <div class="row slds-m-top--medium"  v-if="!exp">
        <div class="slds-form-element col slds-size--medium">
          <Picklist
            :label="$t('campaignDesigner.targetDefinition.camper')"
            :options="config.camper.options || []"
            :disabled="exp"
            labels-prefix="filters"
            searchable
            v-if="filterMode === 'add-remove' && (isCreate || isEdit)"
            v-model="camper" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.camper')"
            :options="config.camper.options || []"
            :value="camper"
            labels-prefix="filters"
            type="picklist"
            v-else />
        </div>

        <div class="slds-form-element col slds-size--medium">
          <GenericFilter
            :filter-mode="filterMode"
            :label="$t('campaignDesigner.targetDefinition.targetCluster.label')"
            :options="config.targetCluster.options"
            :isExP="exp"
            filter-type="included"
            is-multi-picklist
            labels-prefix="campaignDesigner.targetDefinition.targetCluster"
            ref="filter_targetCluster"
            v-if="isCreate || isEdit"
            v-model="targetCluster"
          />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.targetCluster.label')"
            :options="config.targetCluster.options"
            :value="targetCluster"
            labels-prefix="campaignDesigner.targetDefinition.targetCluster"
            type="multipicklist"
            v-else
          />
        </div>


      </div>

      <div class="slds-form-element col row slds-size--medium" v-if="!exp">
              <div v-if="isCreate || isEdit">
                <Picklist
                  :options="config.warrantyExtension.contracts.options"
                  :disabled="warrantyExtensionInclude === 'noFilter'"
                  :label="$t('campaignDesigner.targetDefinition.contracts')"
                  :tooltip="$t('campaignDesigner.targetDefinition.contractsTooltip')"
                  tooltip-direction="right"
                  multipicklist
                  searchable
                  ref="filter_warrantyExtension_contracts"
                  v-model="warrantyExtension.contracts.selected" />
              </div>

              <div v-else>
                <OutputField
                  :label="$t('campaignDesigner.targetDefinition.contracts')"
                  :options="config.warrantyExtension.contracts.options"
                  :value="warrantyExtension.contracts.selected"
                  type="multipicklist"
                  v-if="warrantyExtension.contracts && warrantyExtension.contracts.selected.length" />
              </div>
            </div>

    </Card>


    <!-- Customer Filters -->
    <Card additional-classes="slds-card_boundary" :title="exp ? 'exP ' + $t('campaignDesigner.targetDefinition.customerFilters') : 'exF ' + $t('campaignDesigner.targetDefinition.customerFilters')" v-if="(isCommon || !exp) || !userPreferences.onlyInformativeCampaign">
      <template slot="actions">
        <button class="slds-button slds-button_neutral" v-if="!userPreferences.onlyInformativeCampaign && !hasBothExFExP && !exp && (isCreate || isEdit)" @click="applyToOtherSections">
          {{$t('campaignDesigner.targetDefinition.applyToOtherSections')}}
        </button>
        <!-- <button class="slds-button slds-button_neutral" v-if="hasBothExFExP && userPreferences.onlyInformativeCampaign && (isCreate || isEdit)" @click="applyToOtherSections">
          {{'Apply to both exF/exP'}}
        </button> -->
        <button class="slds-button slds-button_neutral" @click="showManageZipCodesModal = true" v-if="(isOffer || !userPreferences.onlyInformativeCampaign)">
          {{$t(`campaignDesigner.targetDefinition.manageZipCodes.label`)}}
        </button>
      </template>
      <!-- Channel, Communication Channels filter logic -->
      <div class="row slds-m-top--medium">
        <div class="slds-form-element col slds-size--medium">
          <ChannelFilter
            :channels="channelOptions"
            labels-prefix="channels"
            mode="view"
            v-model="channels"
          />
        </div>

        <div class="slds-form-element col slds-size--medium"  v-if="(isOffer || !userPreferences.onlyInformativeCampaign)">
          <Picklist
            :label="$t('campaignDesigner.targetDefinition.communicationChannelsFilterLogic.label')"
            :options="config.communicationChannelsFilterLogic.options"
            :validation="['required']"
            :disabled="!(channels.includes('email') && channels.includes('sms'))"
            ref="filter_channelsLogic"
            labels-prefix="campaignDesigner.targetDefinition.communicationChannelsFilterLogic"
            v-if="isCreate || isEdit"
            v-model="communicationChannelsFilterLogic" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.communicationChannelsFilterLogic.label')"
            :options="config.communicationChannelsFilterLogic.options"
            :value="communicationChannelsFilterLogic"
            labels-prefix="campaignDesigner.targetDefinition.communicationChannelsFilterLogic"
            type="picklist"
            v-else />
        </div>
      </div>

      <!-- Registration on MOC, Exclude Contacts Without Associated Dealer -->
      <div class="row slds-m-top--medium">
        <div class="slds-form-element col slds-size--medium">
          <GenericFilter
            :label="$t('campaignDesigner.targetDefinition.registrationOnMOC')"
            :isExP="exp"
            filter-type="exact"
            ref="filter_registrationOnMOC"
            v-if="isCreate || isEdit"
            v-model="registrationOnMOC" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.registrationOnMOC')"
            :value="registrationOnMOC"
            type="boolean"
            v-else />
        </div>

        <div class="slds-form-element col slds-size--medium" v-if="(isOffer || !userPreferences.onlyInformativeCampaign)">
          <GenericFilter
            :label="$t('campaignDesigner.targetDefinition.excludeContactsWithoutAssociatedDealer')"
            :tooltip="$t('campaignDesigner.targetDefinition.dealerCluster.tooltip')"
            filter-type="exact"
            ref="filter_excludeContactsWithoutAssociatedDealer"
            v-if="isCreate || isEdit"
            v-model="excludeContactsWithoutAssociatedDealer" />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.excludeContactsWithoutAssociatedDealer')"
            :tooltip="$t('campaignDesigner.targetDefinition.dealerCluster.tooltip')"
            :value="excludeContactsWithoutAssociatedDealer"
            type="boolean"
            v-else />
        </div>
      </div>

      <!-- Client Type, Jeep Wave -->
      <!-- <div class="row slds-m-top--medium">

        <div class="slds-form-element col slds-size--medium" v-if="(isOffer)">
          <GenericFilter
            :label="$t('campaignDesigner.targetDefinition.clientType.label')"
            :options="config.clientType.options"
            filter-type="included"
            labels-prefix="campaignDesigner.targetDefinition.clientType"
            is-picklist
            ref="filter_clientType"
            v-if="isCreate || isEdit"
            v-model="clientType"
          />

          <OutputField
            :label="$t('campaignDesigner.targetDefinition.clientType.label')"
            :options="config.clientType.options"
            :value="clientType"
            labels-prefix="campaignDesigner.targetDefinition.clientType"
            type="picklist"
            v-else
          />
        </div>
      </div> -->

      <!-- OCF Date, First Registration Date -->
      <div class="row slds-m-top--medium">
        <div class="slds-form-element col" >
          <div class="slds-size--medium">
          <GenericFilter
            :label="$t('campaignDesigner.targetDefinition.ocfDate')"
            :original-value="originalValues"
            :isExP="exp"
            filter-mode="add-remove"
            input-type="date"
            ref="filter_ocfDate"
            filter-type="range"
            v-if="isCreate || isEdit"
            v-model="ocfDate" />

            <OutputField
              :label="$t('campaignDesigner.targetDefinition.ocfDate')"
              :value="ocfDate"
              item-type="date"
              type="range"
              v-else/>
          </div>
        </div>

        <div class="slds-form-element col"  v-if="(isOffer || !userPreferences.onlyInformativeCampaign)">
          <div class="slds-size--medium">
            <GenericFilter
              filter-mode="add-remove"
              :label="$t('campaignDesigner.targetDefinition.firstRegistrationDate')"
              filter-type="range"
              input-type="date"
              ref="filter_firstRegistrationDate"
              v-if="isCreate || isEdit"
              v-model="firstRegistrationDate" />

            <OutputField
              :label="$t('campaignDesigner.targetDefinition.firstRegistrationDate')"
              :value="firstRegistrationDate"
              item-type="date"
              type="range"
              v-else/>
          </div>
        </div>
      </div>
      <!-- Vocation (exp tab)-->
      <div class="row slds-m-top--medium" v-if="(!userPreferences.onlyInformativeCampaign && !isOffer)">
        <div class="slds-form-element col slds-size--medium" >
            <Picklist
              :label="$t('campaignDesigner.targetDefinition.vocation')"
              :options="config.vocation.options"
              hide-empty-value
              ref="filter_vocation"
              v-if="(isCreate || isEdit)"
              v-model="vocation" />

            <OutputField
              :label="$t('campaignDesigner.targetDefinition.vocation')"
              :options="config.vocation.options"
              :value="vocation"
              type="picklist"
              v-else />
        </div>
      </div>

      <!-- Eligibility to connected services -->
      <Accordion class="slds-m-top--medium">
        <AccordionItem v-if="!exp"
          accordion-item-id="eligibilityToConnectedServices"
          :default-open="this.isContactPlan"
          :title="$t('campaignDesigner.targetDefinition.eligibilityToConnectedServices')">
          <!-- MOPAR Connect, TBM -->
          <div class="row slds-m-top--medium">
            <div class="slds-form-element col row slds-size--medium">
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.moparConnect.label')"
                :options="config.moparConnectInclude.options"
                :disabled="exp"
                accordion-id="eligibilityToConnectedServices"
                class="slds-m-right--small"
                labels-prefix="filters"
                ref="filter_moparConnectInclude"
                v-if="isCreate || isEdit"
                v-model="moparConnectInclude" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.moparConnect.label')"
                :options="config.moparConnectInclude.options"
                :value="moparConnectInclude"
                class="slds-m-right--small"
                labels-prefix="filters"
                type="picklist"
                v-else />

              <OutputField
                :options="config.moparConnect.options"
                :value="moparConnect"
                labels-prefix="campaignDesigner.targetDefinition.moparConnect"
                no-label
                type="picklist"
                v-if="(!isCreate && !isEdit) || (this.isContactPlan && (moparConnectInclude === 'include' || moparConnectInclude === 'exclude'))" />

              <Picklist
                :disabled="(isContactPlan && !moparConnectInclude) || moparConnectInclude === 'noFilter' || exp"
                :options="config.moparConnect.options"
                accordion-id="eligibilityToConnectedServices"
                labels-prefix="campaignDesigner.targetDefinition.moparConnect"
                no-label
                show-empty-value
                v-else
                v-model="moparConnect" />

            </div>

            <div class="slds-form-element col slds-size--medium">
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.tbm')"
                :options="config.moparConnectInclude.options"
                :disabled="exp"
                accordion-id="eligibilityToConnectedServices"
                class="slds-m-right--small"
                labels-prefix="filters"
                ref="filter_tbm"
                v-if="isCreate || isEdit"
                v-model="tbm" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.tbm')"
                :options="config.moparConnectInclude.options"
                :value="tbm"
                class="slds-m-right--small"
                labels-prefix="filters"
                type="picklist"
                v-else />

            </div>
          </div>

          <!-- Map Update, Free Map Update -->
          <div class="row slds-m-top--medium">
            <div class="slds-form-element col row slds-size--medium">
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.mapUpdate.label')"
                :options="config.mapUpdateInclude.options"
                :disabled="exp"
                accordion-id="eligibilityToConnectedServices"
                class="slds-m-right--small"
                labels-prefix="filters"
                v-if="isCreate || isEdit"
                v-model="mapUpdateInclude" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.mapUpdate.label')"
                :options="config.mapUpdateInclude.options"
                :value="mapUpdateInclude"
                class="slds-m-right--small"
                labels-prefix="filters"
                type="picklist"
                v-else />

              <Picklist
                :disabled="mapUpdateInclude === 'noFilter' || exp"
                :options="config.mapUpdate.options"
                accordion-id="eligibilityToConnectedServices"
                labels-prefix="campaignDesigner.targetDefinition.mapUpdate"
                show-empty-value
                no-label
                v-if="isCreate || isEdit"
                v-model="mapUpdate" />

              <OutputField
                :options="config.mapUpdate.options"
                :value="mapUpdate"
                labels-prefix="campaignDesigner.targetDefinition.mapUpdate"
                no-label
                type="picklist"
                v-else />
            </div>

            <div class="slds-form-element col row slds-size--medium">
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.freeMapUpdate.label')"
                :options="config.freeMapUpdateInclude.options"
                :disabled="exp"
                accordion-id="eligibilityToConnectedServices"
                class="slds-m-right--small"
                labels-prefix="filters"
                v-if="isCreate || isEdit"
                v-model="freeMapUpdateInclude" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.freeMapUpdate.label')"
                :options="config.freeMapUpdateInclude.options"
                :value="freeMapUpdateInclude"
                class="slds-m-right--small"
                labels-prefix="filters"
                type="picklist"
                v-else />

              <Picklist
                :disabled="freeMapUpdateInclude === 'noFilter' || exp"
                :options="config.freeMapUpdate.options"
                accordion-id="eligibilityToConnectedServices"
                labels-prefix="campaignDesigner.targetDefinition.freeMapUpdate"
                no-label
                show-empty-value
                v-if="isCreate || isEdit"
                v-model="freeMapUpdate" />

              <OutputField
                :options="config.freeMapUpdate.options"
                :value="freeMapUpdate"
                labels-prefix="campaignDesigner.targetDefinition.freeMapUpdate"
                no-label
                type="picklist"
                v-else />
            </div>
          </div>

          <!-- UConnect Live, Map Care -->
          <div class="row slds-m-top--medium">
            <div class="slds-form-element col slds-size--medium">
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.eligibilityUConnectLive')"
                :options="config.eligibilityUConnectLive.options"
                :disabled="exp"
                accordion-id="eligibilityToConnectedServices"
                labels-prefix="filters"
                searchable
                v-if="isCreate || isEdit"
                v-model="eligibilityUConnectLive" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.eligibilityUConnectLive')"
                :options="config.eligibilityUConnectLive.options"
                :value="eligibilityUConnectLive"
                labels-prefix="filters"
                type="picklist"
                v-else />
            </div>

            <div class="slds-form-element col row slds-size--medium">
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.mapCare.label')"
                :options="config.mapCareInclude.options"
                :disabled="exp"
                accordion-id="eligibilityToConnectedServices"
                class="slds-m-right--small"
                labels-prefix="filters"
                v-if="isCreate || isEdit"
                v-model="mapCareInclude" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.mapCare.label')"
                :options="config.mapCareInclude.options"
                :value="mapCareInclude"
                class="slds-m-right--small"
                labels-prefix="filters"
                type="picklist"
                v-else />

              <Picklist
                :disabled="mapCareInclude === 'noFilter'"
                :options="config.mapCare.options"
                accordion-id="eligibilityToConnectedServices"
                labels-prefix="campaignDesigner.targetDefinition.mapCare"
                no-label
                show-empty-value
                v-if="isCreate || isEdit"
                v-model="mapCare" />

              <OutputField
                :options="config.mapCare.options"
                :value="mapCare"
                labels-prefix="campaignDesigner.targetDefinition.mapCare"
                no-label
                type="picklist"
                v-else />
            </div>
          </div>
        </AccordionItem>
        <AccordionItem v-if="!exp"
          accordion-item-id="indexes"
          :title="`${$t('campaignDesigner.targetDefinition.engagement.label')}, ${$t('campaignDesigner.targetDefinition.pressure.label')}, ${$t('campaignDesigner.targetDefinition.reactivity.label')}`">
          <Accordion>
            <AccordionItem :title="$t('channels.email')" accordion-item-id="emailIndexes">
              <div class="row slds-m-top--medium">
                <div class="slds-form-element col row slds-size--medium">
                  <Picklist
                    :disabled="isContactPlan || exp"
                    :label="$t('campaignDesigner.targetDefinition.engagement.label')"
                    :options="config.emailEngagement.options"
                    :tooltip="$t('campaignDesigner.targetDefinition.engagement.tooltip')"
                    labels-prefix="campaignDesigner.targetDefinition.engagement"
                    show-empty-value
                    tooltip-direction="right"
                    v-if="isCreate || isEdit"
                    v-model="emailEngagement" />

                  <OutputField
                    :label="$t('campaignDesigner.targetDefinition.engagement.label')"
                    :options="config.emailEngagement.options"
                    :tooltip="$t('campaignDesigner.targetDefinition.engagement.tooltip')"
                    :value="emailEngagement"
                    labels-prefix="campaignDesigner.targetDefinition.engagement"
                    tooltip-direction="right"
                    type="picklist"
                    v-else />
                </div>

                <div class="slds-form-element col row slds-size--medium">
                  <Picklist
                    :label="$t('campaignDesigner.targetDefinition.reactivity.label')"
                    :options="config.emailReactivity.options"
                    :disabled="exp"
                    :tooltip="$t('campaignDesigner.targetDefinition.reactivity.tooltip')"
                    labels-prefix="campaignDesigner.targetDefinition.reactivity"
                    show-empty-value
                    tooltip-direction="right"
                    v-if="isCreate || isEdit"
                    v-model="emailReactivity" />

                  <OutputField
                    :label="$t('campaignDesigner.targetDefinition.reactivity.label')"
                    :options="config.emailReactivity.options"
                    :tooltip="$t('campaignDesigner.targetDefinition.reactivity.tooltip')"
                    :value="emailReactivity"
                    labels-prefix="campaignDesigner.targetDefinition.reactivity"
                    tooltip-direction="right"
                    type="picklist"
                    v-else />
                </div>
              </div>

              <div class="row slds-m-top--medium">
                <div class="slds-form-element col row slds-size--medium">
                  <Picklist
                    :label="$t('campaignDesigner.targetDefinition.pressure.label')"
                    :options="config.emailPressure.options"
                    :disabled="exp"
                    labels-prefix="campaignDesigner.targetDefinition.pressure"
                    show-empty-value
                    v-if="isCreate || isEdit"
                    v-model="emailPressure" />

                  <OutputField
                    :label="$t('campaignDesigner.targetDefinition.pressure.label')"
                    :options="config.emailPressure.options"
                    :value="emailPressure"
                    labels-prefix="campaignDesigner.targetDefinition.pressure"
                    type="picklist"
                    v-else />
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </AccordionItem>
      </Accordion>
    </Card>

    <!-- CP Type Target Selection -->
    <CPTypeTargetSelection
      :editable="isCreate || isEdit"
      :engagement-conditions="engagementConditions"
      :engagement-options="config.emailEngagement.options"
      :is-informative-campaign="userPreferences.onlyInformativeCampaign"
      :maintenance-model-cluster="maintenanceModelCluster"
      :maintenance-model-cluster-options="config.maintenanceModelCluster.options"
      :mileage-tag="mileageTag"
      :mileage-tag-options="config.mileageTag.options"
      :months-from-first-registration-date="monthsFromFirstRegistrationDate"
      :show-filters="isContactPlan"
      :validation="['custom']"
      ref="filter_cp"
      v-if="isContactPlan && !exp"
      @apply-to-other-sections-cp="applyToOtherSectionsCP"
      @update="updateCPTypeTarget" />

    <!-- Manage MVS / VIN -->
    <transition name="fade">
      <ManageVINMVS
        :brands="selectedBrands"
        :can-exclude-vin="!sectionNumber || userPreferences.userCanEditExcludedVIN[sectionNumber]"
        :editable="isCreate || isEdit"
        :informative-campaign="userPreferences.onlyInformativeCampaign"
        :mvs="mvs"
        :mvs-to-exclude="mvsToExclude"
        :vin="vin"
        :vin-to-exclude="vinToExclude"
        v-if="showModal && !exp"
        @close="showModal = false"
        @save="updateMvsVin" />
    </transition>
    <transition name="fade">
      <ManageVINLCDV
        :brands="selectedBrands"
        :can-exclude-vin="true"
        :editable="isCreate || isEdit"
        :informative-campaign="userPreferences.onlyInformativeCampaign"
        :mvs="mvs"
        :mvs-to-exclude="mvsToExclude"
        :vin="vin"
        :vin-to-exclude="vinToExclude"
        v-if="showModal && exp"
        @close="showModal = false"
        @save="updateMvsVin" />
    </transition>
    <transition name="fade">
      <ManageZIPCodes
        v-if="showManageZipCodesModal"
        v-model="zipCodes"
        @close="showManageZipCodesModal = false"
        :editable="isCreate || isEdit" />
    </transition>
  </div>

</template>
<script>

import moment from 'moment'
import { validate } from '../../../utils/utils'
import RadioGroup from '../../../slds/RadioGroup'
import Accordion from '../../../slds/Accordion'
import AccordionItem from '../../../slds/AccordionItem'
import BrandFilter from './BrandFilter'
import Card from '../../../slds/Card'
import CPTypeTargetSelection from './CPTypeTargetSelection'
import ChannelFilter from './ChannelFilter'
import DealerClusterFilter from './DealerClusterFilter'
import GenericFilter from './../../filters/GenericFilter.vue'
import ManageZIPCodes from './ManageZIPCodes.vue'
import ManageVINMVS from './ManageVINMVS.vue'
import ManageVINLCDV from './ManageVINLCDV.vue'
import Input from '../../../slds/Input'
import OutputField from '../../../slds/OutputField'
import Picklist from '../../../slds/Picklist'
import ManageZIPVIN from './ManageZIPVIN'

const CONTACT_PLAN_CT = [
  'contact_plan',
  'service_contact_plan'
]

export default {
  props: {
    allBrands: Array,
    brands: Array,
    config: Object,
    isCreate: Boolean,
    isEdit: Boolean,
    loading: Boolean,
    originalValues: Object,
    sectionNumber: String,
    userPreferences: Object,
    value: Object,
    campaignData: Object,
    indexKey: Number,
    exp: Boolean,
    hasBothExFExP: Boolean,
    isCommon: Boolean,
    isOffer: Boolean
  },
  components: {
    Accordion,
    AccordionItem,
    BrandFilter,
    Card,
    ChannelFilter,
    CPTypeTargetSelection,
    DealerClusterFilter,
    GenericFilter,
    Input,
    ManageZIPCodes,
    ManageVINMVS,
    ManageVINLCDV,
    OutputField,
    Picklist,
    RadioGroup,
    ManageZIPVIN
  },
  data () {
    return {
      showManageZipVin: false,
      vocation: '',
      camper: '',
      carAges: {},
      channels: [],
      channelOptions: [],
      clientType: '',
      communicationChannelsFilterLogic: false,
      dealers: {},
      dealerCluster: [],
      eligibilityUConnectLive: false,
      emailEngagement: '',
      emailPressure: '',
      emailReactivity: '',
      engagementConditions: [],
      excludeContactsWithoutAssociatedDealer: false,
      engineSize: [],
      filterTypeToInclude: '',
      filterTypeToIncludeOptions: [
        {
          label: this.$t('campaignDesigner.targetDefinition.mvs'),
          value: 'mvs'
        },
        {
          label: this.$t('campaignDesigner.targetDefinition.vin'),
          value: 'vin'
        }
      ],
      firstRegistrationDate: '',
      fleet: '',
      freeMapUpdate: '',
      freeMapUpdateInclude: '',
      fuelTypes: [],
      exp_fuelTypes: [],
      isContactPlan: false,
      mapCare: '',
      mapCareInclude: '',
      mapUpdate: '',
      mapUpdateInclude: '',
      marketingConsentEditable: false,
      marketingPrivacyConsent: '',
      mileages: [],
      modalTabOpen: '',
      modelYearFrom: [],
      maintenanceModelCluster: [],
      mileageTag: '',
      monthsFromFirstRegistrationDate: 0,
      moparConnect: '',
      moparConnectInclude: '',
      mvs: {},
      mvsToExclude: {},
      ocfDate: [],
      openMVSModalSections: [],
      openVINModalSections: [],
      profilingPrivacyConsent: '',
      purchasedServicesAndAccessories: '',
      registrationOnMOC: '',
      segment: [],
      showModal: false,
      showManageZipCodesModal: false,
      targetCluster: [],
      targetRange: [],
      tbm: '',
      vin: [],
      vinToExclude: [],
      warrantyExtension: '',
      warrantyExtensionInclude: '',
      zipCodes: [],
    }
  },
  async created () {
    //console.log( 'component - created !!!' )
    // Map selected values
    // const scope = this.exp ? 'EXP' : 'EXF'
    // //console.log(this.zipCodes)

    // this.zipCodes = this.zipCodes.filter(m => {
    //   if (this.$store.getters['setting/settings'].market_per_scope[m]) {
    //     this.$store.getters['setting/settings'].market_per_scope[m].includes(scope)
    //   }
    // })
    this.mapValue(this.value)
    //console.log(this.$store)
  },
  mounted () {
    //console.log( 'component - mounted !!!' )
    // Set Marketing consent editable if campaign is only informative
    if (this.userPreferences.onlyInformativeCampaign || this.exp) {
      this.marketingConsentEditable = true
    } else {
      this.marketingPrivacyConsent = 'Y'
      this.$emit('filterChanged', { fieldName: 'marketingPrivacyConsent', newValue: 'Y', exp : this.exp, common : this.isCommon  })
      this.marketingConsentEditable = false
    }
  },
  computed: {
    carAgeDisplayText () {
      if (this.carAges && this.carAges.timeRangeSelector) {
        const { range } = this.carAges
        switch (this.carAges.timeRangeSelector) {
          case 'touchpoint':
            return `${this.$t('general.from')} ${range.touchpoint.touchpointFrom} ${this.$t('general.to')} ${range.touchpoint.touchpointTo}`
          case 'date':
            const formattedDateFrom = moment(range.date.dateFrom).format(this.$t('general.dateFormat'))
            const formattedDateTo = moment(range.date.dateTo).format(this.$t('general.dateFormat'))
            return `${this.$t('general.from')} ${formattedDateFrom} ${this.$t('general.to')} ${formattedDateTo}`
          case 'age':
            return `${range.age.monthAge} ${this.$t('general.months')}`
          default:
            throw new Error(`Unhandled type ${this.carAges.timeRangeSelector}`)
        }
      } else {
        return '\xa0'
      }
    },
    filterTypeToIncludeEditable () {
      const inf = (this.userPreferences.onlyInformativeCampaign || this.exp)
      return inf &&
        (!this.tempMvs || !Object.keys(this.tempMvs)) &&
        (!this.tempVin || !this.tempVin.length)
    },
    filterMode () {
      if (this.userPreferences.onlyInformativeCampaign || this.exp) {
        return 'add-remove'
      } else {
        return 'remove-only'
      }
    },
    carFilterType () {
      if (this.userPreferences.onlyInformativeCampaign || this.exp) {
        return 'NO_OFFER'
      } else if (this.vin) {
        return 'VIN'
      } else {
        return 'MVS'
      }
    },
    selectedBrands () {
      return this.allBrands.filter(brand => this.brands.includes(brand.value))
    },
    hasBrandExF() { //Check if brands picklist has these brands (FCA)
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      return this.brands.some(r=>(brandScopes[r] || []).includes('EXF'))
    }
    // showCPFilters () {
    //   return this.moparConnectInclude === 'exclude' && this.tbm === 'N'
    // }
  },
  methods: {
    updateZipVin (event) {
       const { mvs, mvsToExclude, vin, vinToExclude, zipCodes } = event.data
       //this.$emit('filterChanged', { fieldName: 'mvs', newValue: mvs, exp : this.exp })
       //this.$emit('filterChanged', { fieldName: 'mvsToExclude', newValue: mvsToExclude, exp : this.exp })
       this.$emit('filterChanged', { fieldName: 'vin', newValue: vin, exp : this.exp, common : this.isCommon })
       this.$emit('filterChanged', { fieldName: 'vinToExclude', newValue: vinToExclude, exp : this.exp, common : this.isCommon })
       this.$emit('filterChanged', { fieldName: 'zipCodes', newValue: zipCodes, exp : this.exp, common : this.isCommon })
       this.showManageZipVin = false
    },
    applyToOtherSections () {
      this.$emit('applyToOtherSections', { value: this.mapLocalValue(), sectionNumber: this.sectionNumber, exp: this.exp })
    },
    applyToOtherSectionsCP () {
      const valuesToApply = {
        engagementConditions: this.engagementConditions,
        maintenanceModelCluster: this.maintenanceModelCluster,
        mileageTag: this.mileageTag,
        monthsFromFirstRegistrationDate: this.monthsFromFirstRegistrationDate
      }
      this.$emit('applyToOtherSections', { value: valuesToApply, sectionNumber: this.sectionNumber })
    },
    closeModal () {
      this.showModal = false
      this.tempMvs = {}
      this.tempVin = []
      this.tempVinToExclude = []
    },
    handleDealersUpdate (event) {
      const { value } = event
      this.$emit('filterChanged', { fieldName: 'dealers', newValue: value, exp : this.exp, common : this.isCommon })
    },

    mapLocalValue () {
      const mappedBrands = {
        options: this.allBrands,
        selected: this.brands
      }

      return {
        brands: mappedBrands,
        vocation: this.vocation,
        camper: this.camper,
        carAges: this.carAges,
        communicationChannelsFilterLogic: this.communicationChannelsFilterLogic,
        clientType: this.clientType,
        dealerCluster: this.dealerCluster,
        eligibilityUConnectLive: this.eligibilityUConnectLive,
        emailEngagement: this.emailEngagement,
        emailPressure: this.emailPressure,
        emailReactivity: this.emailReactivity,
        excludeContactsWithoutAssociatedDealer: this.excludeContactsWithoutAssociatedDealer,
        engineSize: this.engineSize,
        fleet: this.fleet,
        freeMapUpdate: this.freeMapUpdate,
        freeMapUpdateInclude: this.freeMapUpdateInclude,
        fuelTypes: this.fuelTypes,
        mapCare: this.mapCare,
        mapCareInclude: this.mapCareInclude,
        mapUpdate: this.mapUpdate,
        mapUpdateInclude: this.mapUpdateInclude,
        marketingPrivacyConsent: this.marketingPrivacyConsent,
        mileages: this.mileages,
        modelYearFrom: this.modelYearFrom,
        moparConnect: this.moparConnect,
        moparConnectInclude: this.moparConnectInclude,
        mvs: this.mvs,
        profilingPrivacyConsent: this.profilingPrivacyConsent,
        purchasedServicesAndAccessories: this.purchasedServicesAndAccessories,
        registrationOnMOC: this.registrationOnMOC,
        segment: this.segment,
        targetCluster: this.targetCluster,
        targetRange: this.targetRange,
        tbm: this.tbm,
        vin: this.vin,
        vinToExclude: this.vinToExclude,
        warrantyExtension: this.warrantyExtension,
        warrantyExtensionInclude: this.warrantyExtensionInclude,
        zipCodes: this.zipCodes
      }
    },
    mapValue (value) {
      //console.log('===AM OFFER===', this.isOffer)
      //console.log('===AM COMMON===', this.isCommon)
      //console.log('====MAP VALUES====', Object.keys(value))
      Object.keys(value).forEach(data => {
        // No offers. Map 1:1 with data fields
        if (this.hasOwnProperty(data)) {
          const value = this.value[data]
          if (value !== undefined) {
            if (typeof value === 'object' && value && value.selected !== undefined) {
              this.$data[data] = value.selected
            } else {
              this.$data[data] = value
            }
          }

          this.$watch(data, (newValue, oldValue) => {
            this.$emit('filterChanged', { fieldName: data, newValue, exp : this.exp, common : this.isCommon  })
          })
        }
      })

      if (this.mvs && Object.keys(this.mvs).length) {
        this.filterTypeToInclude = 'mvs'
      } else if (this.vin && this.vin.length) {
        this.filterTypeToInclude = 'vin'
      }
      this.carAges = value.carAges
      this.warrantyExtension = value.warrantyExtension

      const campaign = this.$store.getters['campaignDesigner/state'].currentCampaign
      const campaignConfig = this.$store.getters['campaignDesigner/state'].currentCampaignConfig
      this.isContactPlan = CONTACT_PLAN_CT.includes(campaign.type)
      this.channels = campaign.config.campaignData.campaignChannel.selected || campaign.config.campaignData.campaignChannel
      this.channelOptions = campaignConfig.campaignData.campaignChannel.options
    },
    updateCPTypeTarget (event) {
      const { field, newValue } = event

      this.$data[field] = newValue
    },
    updateMvsVin (event) {
      const { mvs, mvsToExclude, vin, vinToExclude } = event.data

      this.$emit('filterChanged', { fieldName: 'mvs', newValue: mvs, exp : this.exp, common : this.isCommon  })
      this.$emit('filterChanged', { fieldName: 'mvsToExclude', newValue: mvsToExclude, exp : this.exp, common : this.isCommon  })
      this.$emit('filterChanged', { fieldName: 'vin', newValue: vin, exp : this.exp, common : this.isCommon  })
      this.$emit('filterChanged', { fieldName: 'vinToExclude', newValue: vinToExclude, exp : this.exp, common : this.isCommon  })

      this.showModal = false
    },
    validate () {
      if (this.isCreate || this.isEdit) {
        return validate(this, 'filter')
      } else {
        return true
      }
    }
  },
  watch: {
    exp_fuelTypes (newValue) {
      this.$emit('filterChanged', { fieldName: 'exp_fuelTypes', newValue, exp : this.exp, common : this.isCommon  })
      // this.$emit('filterChanged', { fieldName: 'exp_fuelTypes', newValue, exp : false  })
    },
    moparConnectInclude (newValue) {
      if (!newValue || newValue === 'noFilter') {
        this.moparConnect = null
        this.$emit('filterChanged', { fieldName: 'moparConnect', newValue: null, exp : this.exp, common : this.isCommon  })
      }
      if (this.isContactPlan && (newValue === 'include' || newValue === 'exclude')) {
        this.moparConnect = 'SOT'
        this.$emit('filterChanged', { fieldName: 'moparConnect', newValue: 'SOT', exp : this.exp, common : this.isCommon  })
      }
      this.$emit('filterChanged', { fieldName: 'moparConnectInclude', newValue, exp : this.exp, common : this.isCommon  })
    },
    mapCareInclude (newValue) {
      if (newValue === 'noFilter') {
        this.mapCare = null
        this.$emit('filterChanged', { fieldName: 'mapCare', newValue: null, exp : this.exp, common : this.isCommon  })
      }
      this.$emit('filterChanged', { fieldName: 'mapCareInclude', newValue, exp : this.exp, common : this.isCommon  })
    },
    mapUpdateInclude (newValue) {
      if (newValue === 'noFilter') {
        this.mapUpdate = null
        this.$emit('filterChanged', { fieldName: 'mapUpdate', newValue: null, exp : this.exp, common : this.isCommon  })
      }
      this.$emit('filterChanged', { fieldName: 'mapUpdateInclude', newValue, exp : this.exp, common : this.isCommon  })
    },
    freeMapUpdateInclude (newValue) {
      if (newValue === 'noFilter') {
        this.freeMapUpdate = null
        this.$emit('filterChanged', { fieldName: 'freeMapUpdate', newValue: null, exp : this.exp, common : this.isCommon  })
      }
      this.$emit('filterChanged', { fieldName: 'freeMapUpdateInclude', newValue, exp : this.exp, common : this.isCommon  })
    },
    warrantyExtensionInclude (newValue) {
      if (newValue === 'noFilter') {
        this.warrantyExtension.fromDate = null
        this.warrantyExtension.toDate = null
        this.warrantyExtension.contracts.selected = []
        this.warrantyExtension.carsWithoutWarranties.selected = false
      }
      this.$emit('filterChanged', { fieldName: 'warrantyExtensionInclude', newValue, exp : this.exp, common : this.isCommon  })

      // this.$emit('filterChanged', { fieldName: 'warrantyExtensionInclude', newValue, exp : false  })

    },
    // showCPFilters (newValue, oldValue) {
    //   if (oldValue === true && newValue === false) {
    //     this.$emit('filterChanged', { fieldName: 'engagementConditions', newValue: [] })
    //   }
    // },
    warrantyExtension: {
      handler (newValue) {
        this.$emit('filterChanged', { fieldName: 'warrantyExtension', newValue, exp : this.exp, common : this.isCommon  })
      },
      deep: true
    },
    zipCodes (newValue) {
      // const scope = this.exp ? 'EXP' : 'EXF'
      // //if (this.zipCodes.length > 0) {
      //   for(let market in this.zipCodes) {
      //     if (this.$store.getters['settings/settings'].market_per_scope[market]) {
      //       //console.log(this.$store.getters['setting/settings'].market_per_scope[market])
      //       if (!this.$store.getters['settings/settings'].market_per_scope[market].includes(scope)) {
      //         delete this.zipCodes[market]
      //       }
      //     } else {
      //       delete this.zipCodes[market]
      //     }
      //   }
      //}

    },
    value: {
      handler (newValue) {
        this.mapValue(newValue)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
Input {
  width: unset !important;
}

svg {
  cursor: pointer;
}

.brands-alert {
  height: 100%;
  width: 100%;
  top: 0;

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.full-width {
  width: 100%;
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
}

.col {
  flex-grow: 1;
}

</style>
